module.exports = __webpack_public_path__ + "img/estafeta.b1fd139b.svg";